const colors = {
    brand: {
        primaryBg: ' #010817',
        secondary: ' #FF9800',
        tertiary: ' #D48400',
        quaternary: ' #1B4D90',
        quinary: ' #003B8B',
        secondaryText: ' #333',
        tertiaryText: ' #999',
        quaternaryText: ' #666',
    },
    dark: {
        primary: ' #0070f3',
        secondary: ' #ff4785',
        tertiary: ' #f8312f',
        quaternary: ' #00c853',
        quinary: ' #ffcc00',
        secondaryText: ' #ccc',
        tertiaryText: ' #999',
        quaternaryText: ' #666',
    },
}

export default colors;